import externalLinksMixin from '@/mixins/externalLinks';
import contentLoaderMixin from '@/mixins/contentLoader';

export default {
  mixins: [
    contentLoaderMixin,
    externalLinksMixin,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    availableSocials() {
      const availableSocials = [];
      if (this.facebookLink) {
        availableSocials.push('Facebook');
      }
      if (this.googleLink) {
        availableSocials.push('Google');
      }
      if (this.twitterLink) {
        availableSocials.push('X');
      }

      if (availableSocials.length === 0) {
        return '';
      }

      if (availableSocials.length === 1) {
        return availableSocials[0];
      }

      if (availableSocials.length === 2) {
        return availableSocials.join(
          ' or '
        );
      }

      if (availableSocials.length === 3) {
        return `${availableSocials[0]}, ${availableSocials[1]} or ${availableSocials[2]}`
      }
    },
  },
  created() {
    this.getExternalLogins({})
      .then((response) => {
        this.links = response.data;
        this.isComponentReady = true;
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/socials/socials.js